export default __webpack_public_path__ + "static/media/smart-schedule-3.db49af0a.png";